//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    DASHBOARD_PANEL_DELETE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    dashboardPanelDeleteResult,
} from 'Redux/actions';

function* deleteDashboard({ payload }) {
    try {
        let QUERY = `
            mutation deleteDashboard ($id: String!) {
                result: deleteDashboard (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload?.data
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) yield put(dashboardPanelDeleteResult({ result: data?.result }))

    } catch (exc) {
        yield put(dashboardPanelDeleteResult({ result: false }))
        ExceptionManager(exc, 'Modules/dashboard/views/.components/dashboardPanel/.components/createEditDashboard/redux/saga', 'deleteDashboard', true);
    }
}

function* watchDashboardPanelRequests() {
    yield takeEvery(DASHBOARD_PANEL_DELETE_REQUEST, deleteDashboard);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchDashboardPanelRequests)
    ]);
}